<template>
  <div class="edu-info">
    <div class="container-1200">
      <div class="title wow slideInDown">双创教育</div>
      <div class="info-container">
        <div class="info-list wow slideInLeft">
          <div class="tab-bar">
            <div
              class="tab"
              :class="{ active: tabId === item.dictCode }"
              v-for="item in tabList"
              @click="changeTab(item.dictCode, item.dictLabel)"
              :key="item.dictCode"
            >
              {{ item.dictLabel }}
            </div>
          </div>
          <div class="info-item">
            <div class="info" v-for="item in infoList" :key="item.id">
              <div class="detail">
                <div class="info-title" :title="item.title">
                  <router-link :target="isMobile?'_self':'_blank'" class="link" :to="{path:'/newsDetail', query:{id: item.id}}">{{
                    item.title
                  }}</router-link>
                </div>
                <div class="date">{{item.time | dateFormat('yyyy-MM-dd')}}</div>
              </div>
              <div class="desc" :title="item.des">
                {{ item.des | wordLimit(65) }}
              </div>
            </div>
          </div>
          <router-link :target="isMobile?'_self':'_blank'" :to="{path: '/newsList', query: {typeCode: tabId, name}}" class="more">
            <div class="text">MORE</div>
            <div class="icon"></div>
          </router-link>
        </div>
        <div class="pic-box wow slideInRight">
          <img class="pic" src="@/assets/education.png" alt="" />
          <!-- <img class="logo" src="@/assets/logo.png" alt="" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['edu'],
  computed: {
    isMobile () {
      return /Android|Windows Phone|iPhone|iPod/i.test(navigator.userAgent)
    }
  },
  data () {
    return {
      tabId: 1,
      tabList: [],
      infoList: [],
      name: ''
    }
  },
  watch: {
    edu (n, o) {
      this.tabList = n
      this.tabId = n[0]?.dictCode
      this.name = n[0]?.dictLabel
      this.getInfo([this.tabId])
    }
  },
  methods: {
    changeTab (dictCode, name) {
      this.tabId = dictCode
      this.name = name
      this.getInfo([this.tabId])
    },
    getInfo (typeCode) {
      this.$axios.post(process.env.VUE_APP_jiaxingUrl + '/system/open/getTextListByPage', { pageNum: 1, pageSize: 3, typeCode }).then(res => {
        const data = res.data
        this.infoList = data.rows.slice(0, 3)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edu-info {
  height: 996px;
  background: url(../assets/shuangchuang-bg.png) no-repeat center top;
  .container-1200 {
    width: 1200px;
    margin: 0 auto;
    padding-top: 70px;
  }
  .title {
    position: relative;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
    font-weight: 600;
    color: #fff;
    font-family: MicrosoftYaHei-Bold;
    text-align: center;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -24px;
      width: 80px;
      height: 4px;
      background-color: #fff;
      transform: translateX(-50%);
    }
  }
  .info-container {
    margin-top: 120px;
    height: 648px;
    display: flex;
    overflow: hidden;
    border-radius: 0 30px 0 30px;
    .info-list {
      position: relative;
      padding: 30px 60px 0 30px;
      width: 50%;
      background-color: #334275;
      .tab-bar {
        display: flex;
        height: 64px;
        border-bottom: 1px solid rgba(248, 250, 255, 0.54);
        line-height: 42px;
        font-weight: 600;
        font-size: 22px;
        color: #f8faff;
        .tab {
          position: relative;
          cursor: pointer;
          & + .tab {
            margin-left: 60px;
          }
          &.active {
            color: #b0c3f9;
            &::after {
              content: "";
              width: 24px;
              height: 3px;
              position: absolute;
              left: 50%;
              top: 42px;
              transform: translateX(-50%);
              background-color: #b0c3f9;
            }
          }
        }
      }
      .info-item {
        padding-top: 40px;
        .info {
          & + .info {
            margin-top: 60px;
          }
          .detail {
            display: flex;
            align-items: center;
            height: 36px;
            font-weight: 600;
            color: #fff;
            font-size: 16px;
          }
          .link {
            color: #fff;
            text-decoration: none;
          }
          .info-title {
            width: calc(100% - 100px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .date {
            width: 100px;
            text-align: right;
          }
          .desc {
            line-height: 22px;
            color: rgba($color: #fff, $alpha: 0.63);
            font-size: 14px;
          }
        }
      }
    }
    .pic-box {
      width: 50%;
      position: relative;
      overflow: hidden;
      .pic {
        width: 100%;
        height: 100%;
        transition: all 1s;
        &:hover {
          transform: scale(1.2);
        }
      }
      .logo {
        position: absolute;
        right: 12px;
        top: 20px;
      }
    }
  }
  .more {
    position: absolute;
    right: 60px;
    bottom: 30px;
    height: 23px;
    align-items: center;
    display: flex;
    color: #fff;
    text-decoration: none;
    .icon {
      position: relative;
      margin-left: 12px;
      width: 23px;
      height: 23px;
      border: 2px solid #FBFCFD;
      border-radius: 5px;
      &::after {
        content: '';
        position: absolute;
        left: 6px;
        top: 4px;
        width: 5px;
        height: 5px;
        border: 1px solid #FEFEFD;
        border-top-color: transparent;
        border-right-color: transparent;
        transform: rotate(-45deg);
      }
    }
  }
}
</style>>
